export interface ChunkBox {
  x0: number;
  y0: number;
  x1: number;
  y1: number;
  pageIndex: number;
}

interface BoxFields {
  pageIndex?: number | null;
  x0?: number | null;
  y0?: number | null;
  x1?: number | null;
  y1?: number | null;
}

export const toChunkBox = (chunk: BoxFields): ChunkBox | undefined => {
  const { pageIndex, x0, y0, x1, y1 } = chunk;
  if (pageIndex == null || x0 == null || y0 == null || x1 == null || y1 == null) {
    return undefined;
  }
  if (pageIndex < 0) return undefined;
  return { x0, y0, x1, y1, pageIndex };
};
